module.exports = __webpack_public_path__ + "img/IN.e6950955.png";